import * as React from "react";
import { Pill } from "@/components/ui/pill";

export interface PlanDatesGridProps {
  plannedStartAt: string | null;
  startedAt: string;
  expectedEnd: string | null;
  completedAt: string | null;
}

const ESTIMATED_TOOLTIP =
  "Data estimada (derivada do tempo real, sem declaração do operador). " +
  "A disponibilidade desta janela vale 100% por construção — não reflete tempo improdutivo interno.";

function fmt(value: string | null): string {
  return value ? new Date(value).toLocaleString("pt-BR") : "—";
}

function PlannedCell({
  declaredValue,
  fallback,
}: {
  declaredValue: string | null;
  fallback: string | null;
}): React.ReactElement {
  const declared = declaredValue !== null;
  return (
    <dd className="flex items-center justify-end gap-1.5">
      <span className="font-mono">{fmt(declared ? declaredValue : fallback)}</span>
      {declared ? (
        <Pill tone="neutral">declarado</Pill>
      ) : (
        <span title={ESTIMATED_TOOLTIP} className="cursor-help">
          <Pill tone="warning">estimado</Pill>
        </span>
      )}
    </dd>
  );
}

export function PlanDatesGrid({
  plannedStartAt,
  startedAt,
  expectedEnd,
  completedAt,
}: PlanDatesGridProps): React.ReactElement {
  return (
    <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-[11px] text-text-secondary">
      <dt>Início planejado</dt>
      <PlannedCell declaredValue={plannedStartAt} fallback={startedAt} />

      <dt>Início real</dt>
      {}
      <PlannedCell declaredValue={null} fallback={startedAt} />

      <dt>Fim planejado</dt>
      <PlannedCell declaredValue={expectedEnd} fallback={completedAt} />

      <dt>Fim real</dt>
      <dd className="text-right font-mono">{fmt(completedAt)}</dd>
    </dl>
  );
}
